import angular from 'angular';
import indeterminateProgressDirective from './indeterminate-progress-directive';
import i18n from '../i18n';

/**
 * @ngdoc module
 * @name akamai.components.indeterminate-progress
 *
 * @guideline https://design.akamai.com/components/activity-spinner/
 *
 * @description
 * The indeterminate-progress indicator provides feedback to the user that an operation is
 * in progress when status information cannot be accurately measured. This component can be
 * accompanied by a message about ongoing activity.
 *
 * @example index.html
 * {% raw %}
 * <div class="container" id="smallspinner">
 *  <akam-indeterminate-progress completed="{{completed}}" failed="{{failed}}"
 *    size="small" label="{{label}}"></akam-indeterminate-progress>
 * </div>
 * {% endraw %}
 *
 * @example index.js
 * var controllerFunction = function($scope) {
 *    $scope.completed = false;
 *    $scope.failed = false;
 * };
 * controllerFunction.$inject = ["$scope"];
 * var app = angular.module("indeterminateProgressDemo",
 *  ["akamai.components.indeterminate-progress"]);
 *
 * app.controller("Ctrl", controllerFunction);
 */
export default angular.module('akamai.components.indeterminate-progress', [
  i18n.name
])

/**
 * @ngdoc directive
 *
 * @name akamIndeterminateProgress
 *
 * @description Creates an indeterminate progress control
 *
 * @restrict AE
 *
 * @param {string|TranslateKey} [label] The label to display beneath the
 * spinner. If omitted, a label will not be displayed. Will apply i18n translation
 * on label.
 *
 * @param {boolean} [failed=false] Indicates if the indeterminate progress encountered a `failed`
 * state.
 *
 * @param {boolean} [completed=false] Indicates if the indeterminate progress encountered a
 * `completed` state.
 *
 * @param {string} [size="normal"] The size of the spinner image and font if a label is
 * included. Can be "xs", "small", "normal", "large" or "xl".
 *
 */
  .directive('akamIndeterminateProgress', indeterminateProgressDirective);
